const EventBus = window.VueEventBus
import ProductMixin from '../mixin/tickets'
import CartItemMixin from '../mixin/cart-item'

export default {
  name: 'reservation-ticket-cart-item',
  mixins: [ProductMixin, CartItemMixin],
  computed: {
    itemTypeTitle() {
      return 'Ticket'
    },
  }
}
